<template>
    <div class="biography">
        <h1 class="mb-4">Biografie</h1>

        <b-card-text class="text-left">
            Ich bin 18 Jahre alt, und wohne in dem wünderschönen Niederbayern.
            Momentan mache ich eine Ausbildung zum Fachinformatiker für Anwendungsentwicklung.
            In meiner Freizeit arbeite ich als Administrator und Entwickler bei diesem <a href="http://mcone.eu" target="_blank" style="font-weight: bold">Projekt.</a>
            Mein Schwerpunkt liegt auf der Anwedungsentwicklung mit Java & C#.
            Ich beschäftige mich aber auch mit der Front- & Backend Entwicklung von Websites mittels HTML, CSS, JS & PHP und dem Framework Vue.js.
            Je nach Art meines Projektes benutze ich die Datenbanken MySQL oder MongoDB und deren Bibliotheken.
        </b-card-text>
    </div>
</template>

<script>
    export default {
        name: "Biography"
    }
</script>
